import { defineMessages } from 'react-intl'

const messages = defineMessages({
  rankingTooltip: {
    id: 'RankingChart.rankingTooltip',
    description: 'Texto para indicar la posición de la region en el ranking',
    defaultMessage: 'Posición {position} de {totalRegions}'
  },
  noDataAvailable: {
    id: 'RankingChart.noDataAvailable',
    description: 'Texto para indicar que no hay datos disponibles',
    defaultMessage: 'No hay datos disponibles'
  }
})

export default messages



// WEBPACK FOOTER //
// ./src/modules/Charts/PanelRow/PanelRowValues/messages.js